/* Publish by EComposer at 2026-10-26 16:21:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-osbjqt1rb1a"]=  window.__ectimmers["ecom-osbjqt1rb1a"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-osbjqt1rb1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-osbjqt1rb1a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izo85vd8g9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izo85vd8g9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zs3hn0ctv5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zs3hn0ctv5s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uq0fpglc8zg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uq0fpglc8zg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52rlockdou2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52rlockdou2', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3e90out31vi"]=  window.__ectimmers["ecom-3e90out31vi"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-3e90out31vi"]["cma5o9cpq"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-3e90out31vi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3e90out31vi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8fsgwnsldv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8fsgwnsldv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7yqyiqus9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7yqyiqus9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwcyb6po3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwcyb6po3k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}